






import Vue from "vue";
import TextContent from "@/components/Text/TextContent.vue";
export default Vue.extend({
  name: "NavbarTitle",
  components: { TextContent }
});
